import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import loadash from './plugins/loadash';
import VueRouter from "vue-router";

Vue.config.productionTip = false

import "vuetify/dist/vuetify.min.css"; // Ensure you are using css-loader

// router setup
import routes from "./routes/routes";

import store from "./store";
import ApiService from "./utils/api.service";
ApiService.init(store);

Vue.use(VueRouter);


import GlobalComponents from "./globalComponents";

Vue.use(GlobalComponents);

// configure router
const router = new VueRouter({
  mode: "history",
  routes, // short for routes: routes
  linkExactActiveClass: "nav-item active"
});


// Ensure we checked auth before each page load.
router.beforeEach((to, _from, next) => {
  Promise.all([store.dispatch("auth/check_auth")]);
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters["auth/isAuthenticated"]) {
      next();
    } else {
      next({
        path: "/login"
      });
    }
  } else {
    next();
  }
});

import formatHelpers from './utils/format.helper';
import assetsHelpers from './utils/assets.helper';

const helpers = {
  install(Vue) {
    Vue.prototype.$format = formatHelpers; // we use $ because it's the Vue convention
    Vue.prototype.$assets = assetsHelpers; // we use $ because it's the Vue convention
  }
};

Vue.use(helpers);


new Vue({
  loadash,
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
